export enum ValidationState {
    Invalid = 'invalid',
    None = 'none',
    Valid = 'valid',
    Validating = 'validating',
}
